Auth = require 'db/auth'
ApiAjax = require 'network/api-ajax'
EntityDisplay = require 'lib/entity-display'
NotificationView = require './notification-view'
NotificationEmptyState = require './notification-empty-state'
React = require 'react'
recup = require 'recup'
t = require('views/internal/teacup-with-helpers')('')
TFM = require 'lib/markdown/tfm'
_ = require 'underscore'
SimpleTest = require 'lib/experiments/simple-test'
{ VISIBILITY_ALL, VISIBILITY_UNREAD } = require './visibility-states'
AnimateHeight = require('react-animate-height').default

animatingClasses =
  animating:                  'animating'
  animatingUp:                'animating-up'
  animatingDown:              'animating-down'
  static:                     'static'
  animatingToHeightZero:      'animating-zero'
  animatingToHeightAuto:      'animating-auto'
  staticHeightZero:           'static-zero'
  staticHeightAuto:           'static-auto'

# Update here too:
# stylesheets/components/views/header/notifications.less
animatingTiming = 500

previousMemberID = 0
module.exports = class extends React.Component
  displayName: 'NotificationsList'

  constructor: (props) ->
    super(props)
    { notifications, context } = @props

    isShowCards = SimpleTest('cardNotifications').get('showCards') && context == "header"
    @state = {
      now: new Date()
      isShowCards
      context
      entityDisplay: new EntityDisplay(if isShowCards then 'notificationsGrouped' else 'notification')
    }

    allNotifications = @_notificationPropsToState(notifications)

    # Render the first 30 notifications/groups in the initial render
    # When there's a lot of notifications, we don't want the first render to
    # take a long time
    @state.notifications = allNotifications.slice(0, 30)

    @timeout = setTimeout =>
      if @mounted
        @setState notifications: allNotifications
    , 100

  componentDidMount: ->
    @mounted = true
    @interval = setInterval(@updateNow, 10000)

  componentWillUnmount: ->
    @mounted = false
    clearInterval(@interval)

  componentWillReceiveProps: (nextProps) ->
    clearTimeout(@timeout)
    @setState notifications: @_notificationPropsToState(nextProps.notifications)

  updateNow: =>
    @setState now: new Date()

  _notificationPropsToState: (notifications) ->
    { isShowCards, context } = @state
    if isShowCards
      _.map(notifications.groupings, (notificationGrouping, key) =>
        props = _.extend({ context }, notificationGrouping)
        { archive, active } = _.groupBy notificationGrouping.notifications,
          (n) -> if n.get('unread') then 'active' else 'archive'

        if !active?
          lastDateRead = _.last(archive).get('dateRead')
          if lastDateRead?
            active = _.filter(archive, (n) => n.get('dateRead') == lastDateRead)
          else
            active = _.last(archive, 1)
          archive = _.difference(archive, active)

        props.showArchiveButton = props.unreadCount != props.notifications.length && archive? && archive.length > 0

        props.active = _.map(active, @_generatePropsFromNotif)
        props.archive = _.map(archive, @_generatePropsFromNotif)

        props.toggleRead = =>
          if props.active?
            @toggleStatus props.active

        props.key = key
        return props
      )
    else
      notifications.map (notification) =>
        props = @_generatePropsFromNotif(notification)
        props.key = notification.id
        return props


  _generatePropsFromNotif: (notif, i = 0) =>
    { now, isShowCards, entityDisplay } = @state

    if i == 0
      previousMemberID = 0

    notifProps = notif.getExpandedData()
    notifProps.id = notif.get('id')
    notifProps.type = notif.get('type')
    notifProps.iconKey = notif.get('display')?.translationKey

    notifProps.entities = entityDisplay.getEntities(notif.get 'display')
    for entity in notifProps.entities
      if entity.type == 'comment'
        entity.textHtml = TFM.comments.format(entity.text).output
      else if entity.type == 'relDate'
        entity.text = entityDisplay.relDateText(entity.date, now)

    if notifProps.type == 'cardDueSoon'
      notifProps.isDueDateNotification = true
    else if notifProps.type in [
      'declinedInvitationToBoard'
      'declinedInvitationToOrganization'
    ]
      notifProps.isDeclinedInvitationNotification = true

    if /Enterprise/.test(notifProps.type)
      notifProps.isEnterpriseAdmin = Auth.me().isEnterpriseAdminOf(notif.get('data').enterprise)

    notifProps.isDueSoon = notifProps.type == 'cardDueSoon '
    notifProps.isCommentLike = notif.isCommentLike()
    notifProps.isAddAttachment = notif.isAddAttachment()
    notifProps.idMemberCreator = notif.get('idMemberCreator')

    notifProps.markRead = notif.markRead.bind(notif)
    notifProps.toggleRead = notif.toggleRead.bind(notif)
    notifProps.setData = (data) -> notif.set(data)
    notifProps.navigateToView = notif.navigateToView.bind(notif)

    notifProps.context = @props.context
    member = notif.getMember()

    if (!isShowCards)
      notifProps.member = member
    else if (member? && previousMemberID != member.id)
      notifProps.member = member
      previousMemberID = member.id

    notifProps.deletedMember = notif.get('display')?.entities?.memberCreator?.translationKey == "notification_deleted_account"
    # Prevents a rare occurrence that could cause
    # a member name not to show and prevent too many
    # deleted account tags showing.
    if notifProps.deletedMember && previousMemberID?
      previousMemberID = null
    else
      notifProps.deletedMember = false

    notifProps

  toggleStatus: (notifications) ->
    me = Auth.me()
    status = notifications[0].unread
    cacheRead = notifications[0].dateRead
    dateRead = if status then new Date() else null

    me.setNotifications
      notifications: notifications
      data:
        read: status
        ids: _.chain(notifications)
          .map((notif) -> notif.id)
          .join(',')
          .value()
      setFn: (notif) ->
        notif.setData
          dateRead: dateRead
          unread: !status
      errorFn: (notif) ->
        notif.setData
          dateRead: cacheRead
          unread: status

  hasUnreadNotifications: (notifications) ->
    _.some notifications, (notifProps) ->
      notifProps.unread == true

  render: ->
    { visibilityFilter } = @props
    { notifications, isShowCards } = @state

    if isShowCards
      React.createElement 'div', className: 'notification-list',
        React.createElement NotificationEmptyState,
          visible: visibilityFilter == VISIBILITY_UNREAD && !@hasUnreadNotifications(notifications)
          buttonClicked: @props.visibilityButtonClicked

        notifications.map (notifProps) =>
          height =
            if visibilityFilter == VISIBILITY_UNREAD && notifProps.unread == false
              0
            else
              'auto'

          React.createElement AnimateHeight,
            duration: animatingTiming
            height: height
            animationStateClasses: animatingClasses
            applyInlineTransitions: false
            key: "animate-#{notifProps.key}",
            React.createElement NotificationView, notifProps
    else
      React.createElement 'div', className: 'notification-list',
        notifications.map (notificationProps) =>
          React.createElement NotificationView, notificationProps



// WEBPACK FOOTER //
// ./app/scripts/views/notification/notification-list.coffee